/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CompanyDisplayDTO,
  ErrorResponse,
  TenantDTO,
  UserDisplayDTO,
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class TenantApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Links an existing company to a specified tenant using their IDs.
   *
   * @tags tenant-api
   * @name AddCompanyToTenant
   * @summary Add a company to a tenant by tenant ID
   * @request PUT:/api/tenant/{id}/add-company
   * @secure
   */
  addCompanyToTenant = (
    id: number,
    query: {
      /** @format int64 */
      companyId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<TenantDTO, ErrorResponse | TenantDTO>({
      path: `/api/tenant/${id}/add-company`,
      method: "PUT",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Links an existing company to a specified tenant using their IDs and the tenant name.
   *
   * @tags tenant-api
   * @name AddCompanyToTenant1
   * @summary Add a company to a tenant
   * @request PUT:/api/tenant/add-company
   * @secure
   */
  addCompanyToTenant1 = (
    query: {
      /** @format int64 */
      companyId: number;
      tenantName: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<TenantDTO, ErrorResponse | TenantDTO>({
      path: `/api/tenant/add-company`,
      method: "PUT",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Deletes the specified tenant by its ID. Only empty tenants can be deleted.
   *
   * @tags tenant-api
   * @name DeleteTenant
   * @summary Delete a tenant
   * @request DELETE:/api/tenant/{id}
   * @secure
   */
  deleteTenant = (id: number, params: RequestParams = {}) =>
    this.request<void, ErrorResponse | void>({
      path: `/api/tenant/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Dissolves the specified tenant by its ID. Only empty tenants can be dissolved.
   *
   * @tags tenant-api
   * @name DissolutionTenant
   * @summary Dissolve a tenant
   * @request DELETE:/api/tenant/{id}/dissolution
   * @secure
   */
  dissolutionTenant = (id: number, params: RequestParams = {}) =>
    this.request<void, ErrorResponse | void>({
      path: `/api/tenant/${id}/dissolution`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Returns a list of all tenants in the system.
   *
   * @tags tenant-api
   * @name GetAllTenants
   * @summary Get all tenants
   * @request GET:/api/tenant/all
   * @secure
   */
  getAllTenants = (params: RequestParams = {}) =>
    this.request<TenantDTO[], ErrorResponse>({
      path: `/api/tenant/all`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Returns a list of all companies that belong to the current user's tenant.
   *
   * @tags tenant-api
   * @name GetCurrentTenantCompanies
   * @summary Get all companies of the current tenant
   * @request GET:/api/tenant/current/companies
   * @secure
   */
  getCurrentTenantCompanies = (params: RequestParams = {}) =>
    this.request<CompanyDisplayDTO[], ErrorResponse | CompanyDisplayDTO[]>({
      path: `/api/tenant/current/companies`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Returns a list of all active users from all companies that belong to the current user's tenant.
   *
   * @tags tenant-api
   * @name GetCurrentTenantUsers
   * @summary Get all users of the current tenant
   * @request GET:/api/tenant/current/users
   * @secure
   */
  getCurrentTenantUsers = (params: RequestParams = {}) =>
    this.request<UserDisplayDTO[], ErrorResponse | UserDisplayDTO[]>({
      path: `/api/tenant/current/users`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Returns the information of the tenant associated with the current session.
   *
   * @tags tenant-api
   * @name GetMyTenant
   * @summary Get the current tenant
   * @request GET:/api/tenant/current
   * @secure
   */
  getMyTenant = (params: RequestParams = {}) =>
    this.request<TenantDTO, ErrorResponse>({
      path: `/api/tenant/current`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Returns the information of a tenant based on the provided id.
   *
   * @tags tenant-api
   * @name GetTenant
   * @summary Get a tenant by id
   * @request GET:/api/tenant/{id}
   * @secure
   */
  getTenant = (id: number, params: RequestParams = {}) =>
    this.request<TenantDTO, ErrorResponse | TenantDTO>({
      path: `/api/tenant/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Returns the information of a tenant based on the provided name.
   *
   * @tags tenant-api
   * @name GetTenant1
   * @summary Get a tenant by name
   * @request GET:/api/tenant/name/{tenantName}
   * @secure
   */
  getTenant1 = (tenantName: string, params: RequestParams = {}) =>
    this.request<TenantDTO, ErrorResponse | TenantDTO>({
      path: `/api/tenant/name/${tenantName}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Creates a new tenant with the provided name.
   *
   * @tags tenant-api
   * @name InitiateTenant
   * @summary Initiate a new tenant
   * @request POST:/api/tenant
   * @secure
   */
  initiateTenant = (
    query: {
      tenantName: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<TenantDTO, ErrorResponse | TenantDTO>({
      path: `/api/tenant`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Removes an existing company from a specified tenant using their IDs.
   *
   * @tags tenant-api
   * @name RemoveCompanyFromTenant
   * @summary Remove a company from a tenant
   * @request DELETE:/api/tenant/{id}/remove-company
   * @secure
   */
  removeCompanyFromTenant = (
    id: number,
    query: {
      /** @format int64 */
      companyId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<TenantDTO, ErrorResponse | TenantDTO>({
      path: `/api/tenant/${id}/remove-company`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Updates the name of a specified tenant using its ID and the new name.
   *
   * @tags tenant-api
   * @name UpdateTenantName
   * @summary Update tenant name
   * @request PUT:/api/tenant/{id}/update-name
   * @secure
   */
  updateTenantName = (
    id: number,
    query: {
      tenantNewName: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<TenantDTO, ErrorResponse | TenantDTO>({
      path: `/api/tenant/${id}/update-name`,
      method: "PUT",
      query: query,
      secure: true,
      ...params,
    });
}
